import { Builder } from '@builder.io/sdk';
import { Accordion } from './Accordion';

const AccordionConfig = {
  name: 'Accordion',
  inputs: [
    {
      name: 'heading',
      type: 'string',
    },
    {
      name: 'showIndex',
      type: 'boolean',
      defaultValue: false,
      helperText: 'Show index of the accordion item',
    },
    {
      name: 'narrow',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Narrow the accordion width',
    },
    {
      name: 'isFaqs',
      friendlyName: 'Is FAQs',
      type: 'boolean',
      defaultValue: false,
      helperText: 'Adds FAQ schema.org type',
    },
    {
      name: 'items',
      type: 'list',
      subFields: [
        {
          name: 'title',
          type: 'string',
          required: true,
        },
        {
          name: 'content',
          type: 'richText',
        },
      ],
    },
  ],
};

Builder.registerComponent(Accordion, AccordionConfig);
